module.exports = __webpack_public_path__ + "img/already_insured.534291f4.png";